<div class="relative">
    <div class="w-full h-full rounded-full md:border-[3px] border-1 border-orange md:p-[3px] ease-in-out transition-all delay-400">
        @if (img && img!='' ) {
            <img class="w-full h-full rounded-full mx-auto cursor-pointer"  [src]="img"
            alt="updatedPhoto" (click)="onClickImage.emit()" #fotoRecorte />
        } @else {
            <img class="w-full h-full rounded-full mx-auto"  src="./assets/profile_picture.png"
            alt="noUserImage" #noFoto />
        }

    </div>
    @if (isEditable) {
        <button (click)="onEdit.emit()"
        class="rounded-full bg-orange_light text-vivid-royal-950 absolute top-0 right-0 w-10 h-10 p-5 flex items-center mx-auto justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/><circle cx="12" cy="13" r="3"/></svg>
      </button>
    }
    
  </div>